import { t } from "@/i18n-js/instance";
import { Button } from "@circle-react-uikit/Button";
import { Typography } from "@circle-react-uikit/Typography";

interface UploadButtonsProps {
  handleChangeCoverClick?: (event: any) => void;
}

export const UploadButtons = ({
  handleChangeCoverClick,
}: UploadButtonsProps) => (
  <div className="bg-secondary border-primary flex aspect-[2.7388059701] w-full flex-col items-center justify-center rounded-lg border border-dashed">
    <Typography.LabelXs>
      {t("image_upload.works_with_image_type")}
    </Typography.LabelXs>
    <Typography.LabelXs>
      {t("courses.edit.lesson.cover_media_help")}
    </Typography.LabelXs>
    <Button
      variant="secondary"
      type="button"
      className="mt-4"
      onClick={handleChangeCoverClick}
    >
      {t("upload")}
    </Button>
  </div>
);
